// AR
export const propAuthLocksHc = {
  autoridades: {
    breadcrumbCurrent: "السلطات المختصة",
    selectorLabel: "اختر سلطة الشرطة في منطقتك",

    // أجزاء الحالة المشتركة
    msgConnected: "متصل.",
    msgValidated: "تم التحقق.",
    msgValidationError: "خطأ في التحقق.",

    // SES Hospedajes
    sesSubtitle: "كتابة الدولة للأمن – وزارة الداخلية",
    sesConnectedText: "سيتم إرسال تسجيلات الوصول تلقائيًا إلى SES Hospedajes.",
    sesVerifyCreds: "تحقق من بيانات الاعتماد التي أدخلتها.",
    sesNotConnected: "لم تربط حساب SES Hospedajes بعد.",
    updateConnectedAccount: "تحديث الحساب المتصل",

    // Ertzaintza A19
    ertzSubtitle: "شرطة إقليم الباسك – سجل المسافرين",
    ertzConnectedText: "سيتم إرسال تسجيلات الوصول تلقائيًا إلى Ertzaintza.",
    ertzVerifyCif: "تحقق من رقم CIF ورمز المنشأة.",
    ertzCredsSaved: 'تم حفظ بيانات الاعتماد. اضغط على "التحقق من الاتصال" للتأكد من الوصول.',
    ertzCifLabel: "رقم CIF للمنشأة",
    ertzCifPlaceholder: "مثال: B12345678",
    ertzCifHint: "بحد أقصى 10 أحرف. رقم CIF للمؤجّر المسجّل لدى Ertzaintza.",
    ertzCodeLabel: "رمز المنشأة",
    ertzCodePlaceholder: "مثال: 01000001",
    ertzCodeHint: "يُخصَّص من قِبل Ertzaintza عند تسجيل المنشأة.",
    envLabel: "البيئة",
    envPre: "ما قبل الإنتاج (اختبار)",
    envPro: "الإنتاج",
    envHint: 'استخدم "ما قبل الإنتاج" للتحقق قبل التفعيل في الإنتاج.',
    verifying: "جارٍ التحقق...",
    verifyConnection: "التحقق من الاتصال",
    saving: "جارٍ الحفظ...",
    updateCredentials: "تحديث بيانات الاعتماد",
    saveAndConnect: "حفظ واتصال",

    // Mossos d'Esquadra
    mossosSubtitle: "Generalitat de Catalunya – Registre de viatgers d'establiments d'hostalatge",

    // SIRE
    sireSubtitle: "نظام معلومات تسجيل الأجانب – Migración Colombia",
    sireConnectedText: "سيتم إرسال تسجيلات الوصول تلقائيًا.",
    sireRevisaCreds: "تحقق من بيانات الاعتماد.",
    docTypeLabel: "نوع المستند",
    selectTypePlaceholder: "اختر النوع",
    docNumberLabel: "رقم المستند",
    docNumberPlaceholder: "مثال: 123456789",
    passwordLabel: "كلمة المرور",
    sirePasswordPlaceholder: "كلمة مرور SIRE",
    showHideTitle: "إظهار/إخفاء",
    saveChanges: "حفظ التغييرات",

    // TRA
    traSubtitle: "وزارة التجارة والصناعة والسياحة – رمز التفويض",
    traReportsText: "تم تفعيل التقارير التلقائية.",
    traRevisaToken: "تحقق من الرمز/RNT.",
    traTokenLabel: "رمز التفويض",
    traTokenPlaceholder: "الصق هنا الرمز الصادر عن TRA",
    traCurrentToken: "الرمز الحالي: {token}",
    traNoTokenHint: "إذا لم يكن لديك رمز PMS بعد، يمكنك إنشاؤه من",
    traRntLabel: "رقم RNT للمنشأة",
    traRntPlaceholder: "أرقام فقط (مثال: 123456)",
    traRntHint: "يجب أن يكون رقم RNT الفعّال للمنشأة (من 5 إلى 15 رقمًا).",

    // أنواع المستندات (كولومبيا)
    docTypeCitizenId: "بطاقة هوية المواطن",
    docTypeForeignerId: "بطاقة هوية الأجانب",

    // Alloggiati Web (نص افتراضي متبقٍّ)
    alloggiatiIdPlaceholder: "مثال: 1234",

    // إشعارات / رسائل السكربت
    needSaveListing: "عليك حفظ القائمة أولًا.",
    authChangedErtz: "تم تغيير السلطة إلى Ertzaintza (إقليم الباسك).",
    authChangedMossos: "تم تغيير السلطة إلى Mossos d'Esquadra (كتالونيا).",
    authChangedSes: "تم تغيير السلطة إلى SES Hospedajes.",
    authChangeError: "تعذّر تغيير السلطة.",
    ertzSaved: "تم حفظ بيانات اعتماد Ertzaintza.",
    saveGenericError: "خطأ أثناء الحفظ.",
    ertzSaveError: "خطأ في حفظ بيانات اعتماد Ertzaintza.",
    ertzTestOk: "تم التحقق من الاتصال بـ Ertzaintza بنجاح.",
    testFailedCheck: "فشل التحقق. راجع البيانات.",
    ertzTestError: "خطأ في التحقق من الاتصال بـ Ertzaintza.",
    mossosNeedCreds: "أدخل اسم المستخدم وكلمة المرور لموقع Mossos.",
    mossosFound: "تم العثور على {count} منشأة. اختر منشأتك. | تم العثور على {count} منشآت. اختر منشأتك.",
    mossosNoEstablishments: "لم يتم العثور على منشآت في هذا الحساب.",
    mossosConnError: "تعذّر الاتصال بـ Mossos. راجع اسم المستخدم وكلمة المرور.",
    mossosNeedFields: "أكمل المعرّف الشرطي ورمز المنشأة.",
    mossosSaved: "تم حفظ بيانات اعتماد Mossos.",
    mossosSaveError: "خطأ في حفظ بيانات اعتماد Mossos.",
    mossosTestOk: "تم التحقق من الاتصال بـ Mossos بنجاح.",
    mossosTestError: "خطأ في التحقق من الاتصال بـ Mossos.",
    mossosFileOk: "تم إنشاء الملف. ارفعه على موقع Mossos (Fitxers massius).",
    mossosNoTravelers: "لا يوجد مسافرون بانتظار الإرسال.",
    mossosConfigFirst: "قم بإعداد المنشأة أولًا.",
    mossosFileError: "تعذّر إنشاء الملف.",
    sireCompleteData: "أكمل البيانات المطلوبة لـ SIRE.",
    sireSaved: "تم حفظ SIRE بنجاح.",
    sireSaveFailed: "تعذّر حفظ SIRE.",
    sireSaveError: "خطأ في حفظ SIRE.",
    sireDeactivated: "تم إلغاء تفعيل SIRE.",
    sireActivated: "تم تفعيل SIRE.",
    sireStateFailed: "تعذّر تغيير حالة SIRE.",
    sireStateError: "خطأ في تغيير حالة SIRE.",
    traNeedToken: "أدخل الرمز ورقم RNT صالح (أرقام فقط).",
    traSaved: "تم حفظ TRA بنجاح.",
    traSaveFailed: "تعذّر حفظ TRA.",
    traSaveError: "خطأ في حفظ TRA.",
    traDeactivated: "تم إلغاء تفعيل TRA.",
    traActivated: "تم تفعيل TRA.",
    traStateFailed: "تعذّر تغيير حالة TRA.",
    traStateError: "خطأ في تغيير حالة TRA.",
    stateChangeFailed: "تعذّر تغيير الحالة.",
    alloggiatiStateError: "خطأ في تغيير حالة Alloggiati Web.",
    ross1000StateError: "خطأ في تغيير حالة ROSS 1000.",
  },

  smartLocks: {
    loadingConfig: "جارٍ تحميل الإعدادات…",
    accessKeyTypeLabel: "نوع مفتاح الوصول",
    selectLockPlaceholder: "اختر القفل",
    optionStatic: "مفتاح ثابت",
    optionTtlock: "TTLock - قفل ديناميكي",
    optionTedee: "Tedee - قفل ديناميكي",
    optionShelly: "Shelly - مرحّل ذكي",
    optionYacan: "YACAN - قفل ذكي",
    optionAkiles: "Akiles - قفل ذكي",
    optionOther: "علامة تجارية أخرى غير مدرجة هنا…",
    pillTedee: "وصول ديناميكي (Tedee)",
    pillTtlock: "وصول ديناميكي (TTLock)",
    pillShelly: "فتح عن بُعد (Shelly)",
    pillYacan: "وصول مُدار (YACAN)",
    pillAkiles: "Akiles متصل",
    pillStatic: "وصول ثابت",
    pillOther: "راسلنا وسنساعدك على دمجه",
    disconnecting: "جارٍ قطع الاتصال…",
    disconnect: "قطع الاتصال",
    emptyTitle: "اربط قفلك الذكي",
    emptyText: "اختر علامتك التجارية من القائمة المنسدلة أعلاه لربطها وإنشاء مفتاح جديد تلقائيًا مع كل حجز.",
    emptyBrandOther: "علامات تجارية أخرى",
    unitFallback: "الوحدة {id}",
    staticModeInfo: "تم اختيار الوضع الثابت. أدخل مفتاحًا واضغط على حفظ لتطبيقه.",
    saveTypeError: "تعذّر حفظ نوع الوصول",
    disconnectSuccess: "تم قطع اتصال القفل",
    disconnectError: "تعذّر قطع اتصال القفل.",
  },

  rates: {
    pageTitle: "الأسعار",
    loading: "جارٍ تحميل الأسعار…",
    roomsCount: "{count} غرفة | {count} غرف",
    singleUnit: "وحدة واحدة",
    newBtn: "جديد",
    colName: "الاسم",
    colAdjustment: "التعديل",
    colFinal: "السعر النهائي",
    labelMain: "رئيسي",
    labelDerived: "مشتق",
    base: "أساسي",
    editTitle: "تعديل",
    copyTitle: "نسخ إلى وحدة أخرى",
    deleteTitle: "حذف",
    noDerived: "لا توجد أسعار مشتقة لخطة الأسعار هذه.",
    emptyTitle: "لا توجد أسعار رئيسية",
    emptyText: "أنشئ سعرًا رئيسيًا لهذه الوحدة ثم ستتمكّن من إنشاء أسعار مشتقة.",
    emptyCreate: "إنشاء أول سعر رئيسي",
    globalEmptyTitle: "لا توجد وحدات محمّلة",
    globalEmptyText: "أنشئ الغرف/الوحدات أولًا لتتمكّن من إدارة الأسعار.",
    editRate: "تعديل السعر",
    newRate: "سعر جديد",
    fieldName: "الاسم",
    namePlaceholder: "مثال: سعر مرن",
    validityPeriod: "فترة الصلاحية",
    validityPermanent: "دائم",
    validityCustom: "مخصّص",
    validityHintCustom: "اختياري: يُطبَّق ضمن النطاق فقط",
    validityHintPermanent: "السعر صالح دائمًا",
    startLabel: "البداية",
    endLabel: "النهاية",
    pricePerNight: "السعر لكل ليلة",
    taxIncluded: "شامل الضرائب",
    occupancy: "الإشغال",
    guestsNumber: "عدد النزلاء",
    minStay: "الحد الأدنى للإقامة",
    maxStay: "الحد الأقصى للإقامة",
    description: "الوصف",
    optional: "اختياري",
    rateplanBase: "خطة السعر الأساسية",
    selectRateplanBase: "اختر خطة سعر أساسية",
    rateplanBaseHint: "اختر خطة السعر التي سيُحسب على أساسها هذا السعر المشتق.",
    derivedNamePlaceholder: "مثال: Booking.com، Airbnb…",
    derivedNameHint: "يساعدك هذا الاسم على تمييز السعر عند ربط قنوات OTA.",
    adjustmentType: "نوع التعديل",
    percentage: "نسبة مئوية",
    fixedAmount: "مبلغ ثابت",
    adjustmentValue: "قيمة التعديل",
    adjustmentValueHint: "(قيمة سالبة للخصم)",
    preview: "معاينة",
    basePrice: "السعر الأساسي",
    increment: "زيادة",
    discount: "خصم",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ...",
    update: "تحديث",
    create: "إنشاء",
    deleteModalTitle: "حذف السعر",
    deleteWarnStrong: "لا يمكن التراجع عن هذا الإجراء.",
    deleteWarnLead: "أنت على وشك حذف:",
    deleteCascadeLabel: "احذف أيضًا الأسعار المشتقة منه ({count})",
    deleteCascadeHint: "إذا كان أي سعر مشتق مرتبطًا بقناة OTA، فسيتم حظر الحذف.",
    deleteConfirmLabel: "اكتب الاسم بدقّة للتأكيد:",
    deleteConfirmPlaceholder: "اكتب الاسم بدقّة",
    deleteConfirmHint: "يمنع هذا عمليات الحذف غير المقصودة.",
    deleting: "جارٍ الحذف...",
    deleteConfirmBtn: "حذف نهائي",
    copyModalTitle: "نسخ السعر إلى وحدة أخرى",
    copyOrigin: "المصدر:",
    copyRate: "السعر:",
    copyTargetUnit: "الوحدة الهدف",
    selectUnit: "اختر وحدة",
    copySameUnitHint: "لا يمكنك النسخ إلى الوحدة نفسها.",
    copyTargetBaseRate: "السعر الأساسي الهدف",
    selectMainRate: "اختر سعرًا رئيسيًا",
    copyDerivedHint: "سيتم ربط هذا السعر المشتق بذلك السعر الرئيسي في الوحدة الهدف.",
    copyNoMainRates: "الوحدة الهدف لا تحتوي على أسعار رئيسية. أنشئ أو انسخ سعرًا رئيسيًا أولًا.",
    copyNewNameLabel: "الاسم في الوجهة",
    copyRenameHint: "يمكنك إعادة التسمية لتجنّب التكرار.",
    copyCascadeLabel: "انسخ أيضًا الأسعار المشتقة ({count})",
    copyCascadeHint: "سيتم إنشاء أسعار مشتقة جديدة تشير إلى خطة السعر الرئيسية المنسوخة.",
    copying: "جارٍ النسخ...",
    copyBtn: "نسخ",

    // إشعارات / رسائل السكربت
    loadError: "خطأ في تحميل الأسعار",
    rangeErrorSelect: "يجب تحديد نطاق تواريخ صالح",
    rangeErrorStartEnd: "لا يمكن أن يكون تاريخ البداية بعد تاريخ النهاية",
    rangeErrorMinStay: "الحد الأدنى للإقامة هو {minStay} ليالٍ، لكن النطاق المحدّد يحتوي على {nights} ليالٍ",
    invalidUnit: "وحدة غير صالحة",
    completeRequired: "أكمل الحقول المطلوبة",
    updated: "تم التحديث",
    created: "تم الإنشاء",
    saveError: "خطأ في الحفظ",
    deleted: "تم الحذف",
    deleteLinkedOta: "لا يمكن الحذف: مرتبط بقناة OTA.",
    deleteGenericError: "خطأ في الحذف",
    deleteDerivedError: "تعذّر حذف السعر المشتق",
    copied: "تم النسخ",
    copyGenericError: "خطأ في النسخ",
    invalidTargetUnit: "الوحدة الهدف غير صالحة",
    selectTargetBaseError: "اختر السعر الأساسي الهدف لربط السعر المشتق.",
    invalidTargetBaseError: "السعر الأساسي الهدف المحدّد غير صالح للوحدة الهدف.",
    defaultRateName: "سعر",
    defaultDerivedName: "مشتق",
    copySuffix: "(نسخة)",
  },
};
